import React from 'react';

import { ContentTuck, HeaderScrim, LayoutBackdropReset, ModuleElementDiv, Page } from './PageShell.styles';

export type PageShellProps = {
  /** Computed CSS string handed down by ModuleElement. */
  styleText?: string;
  className?: string;
  children: React.ReactNode;
};

/**
 * Wraps a page's center content. Applies the `styleText`/`className` that
 * ModuleElement passes in, then lays the page sections out in a single column.
 * Does NOT render the left menu, top bar or right-hand panel — those are layout.
 */
export const PageShell = ({ styleText = '', className, children }: PageShellProps): React.ReactElement => (
  <React.Fragment>
    <LayoutBackdropReset />
    <ContentTuck />
    <HeaderScrim aria-hidden="true" />
    <ModuleElementDiv className={`ai-bb-page-root ${className ?? ''}`.trim()} $styleText={styleText}>
      <Page>{children}</Page>
    </ModuleElementDiv>
  </React.Fragment>
);

export default PageShell;